import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Overline, MaskLines } from "../components/Motion";
import { SERVICES } from "../lib/data";

const ORDER = ["financial-planning", "business-consultancy", "valuation"];
const CURATED = ORDER.map((id) => SERVICES.find((s) => s.id === id)).filter(Boolean);

export default function Services() {
  return (
    <div>
      {/* Header */}
      <section className="pt-40 md:pt-52 pb-16 relative z-10" data-testid="services-header">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Overline>Services</Overline>
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight mt-6 font-medium">
            <MaskLines lines={["What Ethikally", <span key="e" className="italic text-forest">offers.</span>]} delay={0.1} />
          </h1>
        </div>
      </section>

      {/* Service rectangles — stacked */}
      <section className="pb-28 relative z-10" data-testid="services-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-6 lg:space-y-8">
          {CURATED.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08}>
              <div
                data-testid={`service-card-${s.id}`}
                className="group bg-white border border-navy/10 p-8 md:p-10 lg:p-12 grid md:grid-cols-12 gap-6 md:gap-10 items-start hover:border-forest/40 hover:shadow-[0_20px_60px_-25px_rgba(15,42,74,0.25)] transition-all duration-300"
              >
                <div className="md:col-span-5">
                  <span className="font-mono text-forest text-sm">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="font-heading text-3xl md:text-4xl tracking-tight mt-4 group-hover:text-forest transition-colors">
                    {s.title}
                  </h3>
                </div>
                <div className="md:col-span-7 flex flex-col items-start">
                  <p className="text-navy/60 text-lg leading-relaxed">{s.desc}</p>
                  <Link
                    to="/contact"
                    data-testid={`service-quote-${s.id}`}
                    className="group/btn inline-flex items-center gap-2 mt-8 rounded-full border border-navy px-6 py-3 text-sm font-medium text-navy hover:bg-navy hover:text-cream transition-colors duration-300"
                  >
                    Get a Quote
                    <ArrowRight size={16} className="group-hover/btn:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
